import React, {useState, useEffect} from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';

// import {Condicion_Estudiante, Condicion_Representante} from '../funciones';
import { Ver_Valores, conexiones } from '../../../constantes';

import Cargando from '../../../componentes/esperar/cargar';

import Typography from '@mui/material/Typography';

import { Notas_Promedio } from '../academico/control de estudio/comunes';

import Scrollbars from '../../../componentes/herramientas/scrolbars';
import { Nota_Entera } from '../academico/control de estudio/comunes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

function NotasR (props) {
    const {User} = Ver_Valores();
    const [state, setState]= useState({esperar:true, Dialogo:{open:false}});

    const cambiarState = (nuevostate)=>{
        setState({...state, ...nuevostate, cambio:true})
    }

       
    const Inicio = async() =>{
        let respu= await conexiones.Leer_C(['uecla_Representante'],{
            uecla_Representante:{_id:User._id}
        })
        const repres= respu.datos.uecla_Representante[0];
        respu = await conexiones.Leer_C(['uecla_Asigntura'],{
            uecla_Asignatura:{}
        })
        let asignaturas =[];
        if (respu.Respuesta==='Ok'){
            asignaturas = respu.datos.uecla_Asignatura.map(val=> val.valores).sort((a,b)=> Number(a.item)>Number(b.item) ? 1 : -1);
            
        }
        let mensualidades=[];
        let notas = [];
        let dia;
        for (var i=0; i< repres.valores.representados.length; i++){
            let dato = {
                ...repres.valores.representados[i], 
                representante:{
                    _id: repres.valores._id ? repres.valores._id : repres._id,
                    cedula: repres.valores.cedula,
                    nombres:repres.valores.nombres,
                    apellidos:repres.valores.apellidos,
                }
            }
            let respuesta= await conexiones.Resumen(dato);
            if (respuesta.Respuesta==='Ok'){
                mensualidades=[...mensualidades, ...respuesta.mensualidad]
            }
            respuesta=await conexiones.Leer_C(['uecla_NNota'],{
                uecla_NNota:{"valores._id_estudiante":repres.valores.representados[i]._id}
            });
            
            if (respuesta.Respuesta==='Ok'){
                let nota = Notas_Promedio(asignaturas, respuesta.datos.uecla_NNota);
                notas=[...notas, ...nota];
                dia=respuesta.dia;
            }
        }
        let notasn=[];
        notas= notas.sort((a,b)=> a.periodo>b.periodo ? -1 :1);
        for (var j=0;j<notas.length;j++){
            let nota = notas[j];
            const pos = mensualidades.findIndex(f=>f.periodo===nota.periodo && f._id_estudiante===nota._id_estudiante);
            if (pos!==-1){
                const fecha = new Date(dia);
                const pos1 = Ver_Valores().config.Listas.lista_Meses.findIndex(f=>Number(f.mes)===fecha.getMonth()+1);
                const mes= Ver_Valores().config.Listas.lista_Meses[pos1];
                if (mensualidades[pos][mes.value]){
                    notasn=[...notasn, nota];
                }else{
                    notasn=[...notasn, {
                        ...nota,
                        mensaje:`Para poder visualizar notas debe estar Solvente`
                    }];
                }
            }
        }

        cambiarState({esperar:false, asignaturas, notas:notasn})
    }
    
    const NotasLapso = (notas)=>{
        
        let asig = state.asignaturas.filter(f=> f.grado.titulo===notas.grado)
        
        
        return asig.map(valor=>{
            
            const color=(valor.grado.value==='1er' && Number(valor.item)<8)
            || (valor.grado.value==='2do' && Number(valor.item)<8)
            || (valor.grado.value==='3er' && Number(valor.item)<9)
            || (valor.grado.value==='4to' && Number(valor.item)<10)
            || (valor.grado.value==='5to' && Number(valor.item)<11)
            ? '' :'#fca174';
            
            return  <Stack key={valor._id}
                        direction="row"
                        sx={{pl:1}}
                    >
                        <Typography variant="subtitle2" sx={{color ,width:'40%', textAlign:'left', fontWeight:'bold'}} noWrap>
                            {valor.asignatura}  
                        </Typography>
                        <Typography variant="subtitle2" sx={{color, width:'15%', textAlign:'right', cursor:'pointer'}} >
                            {notas[`1lapso-${valor._id}-consejo`] 
                                ?   Number(notas[`1lapso-${valor._id}-consejo`]).toFixed(2) 
                                :  notas[`1lapso-${valor._id}-art112`] 
                                ?   Number(notas[`1lapso-${valor._id}-art112`]).toFixed(2) 
                                :   notas[`1lapso-${valor._id}`] 
                                ?   Number(notas[`${'1lapso'}-${valor._id}`]).toFixed(2) : ''
                            }
                        </Typography>
                        <Typography variant="subtitle2" sx={{color, width:'15%', textAlign:'right', cursor:'pointer'}} >
                            {notas[`2lapso-${valor._id}-consejo`] 
                                ?   Number(notas[`2lapso-${valor._id}-consejo`]).toFixed(2) 
                                :  notas[`2lapso-${valor._id}-art112`] 
                                ?   Number(notas[`2lapso-${valor._id}-art112`]).toFixed(2) 
                                :   notas[`2lapso-${valor._id}`] 
                                ?   Number(notas[`${'2lapso'}-${valor._id}`]).toFixed(2) : ''
                            }
                        </Typography>
                        <Typography variant="subtitle2" sx={{color, width:'15%', textAlign:'right', cursor:'pointer'}} >
                            {notas[`3lapso-${valor._id}-consejo`] 
                                ?   Number(notas[`3lapso-${valor._id}-consejo`]).toFixed(2) 
                                :  notas[`3lapso-${valor._id}-art112`] 
                                ?   Number(notas[`3lapso-${valor._id}-art112`]).toFixed(2) 
                                :   notas[`3lapso-${valor._id}`] 
                                ?   Number(notas[`${'3lapso'}-${valor._id}`]).toFixed(2) : ''
                            }
                        </Typography>
                        <Typography variant="subtitle2" sx={{color, width:'15%', textAlign:'right', cursor:'pointer'}} >
                            {notas[`${valor._id}-def`] 
                                ?   Nota_Entera(notas[`${valor._id}-def`])
                                :  ''
                                
                            }
                        </Typography>
                    </Stack>
        })
        
    }

    useEffect(()=>{
        Inicio()
        return ()=>{}
    }, [props])

    const {Config}= props;
    return state.esperar ? <Cargando open={state.esperar} Config={Config}/> : (
        <Box>
            <Grid container spacing={0.5}>
                <Grid item xs={12}>
                    <Box sx={{height:'79vh'}}>
                        <Scrollbars>
                            {
                                state.notas
                                    ?   <Grid container spacing={2}
                                                sx={{
                                                    // justifyContent: "center",
                                                    alignItems: "flex-end",
                                                }}
                                        >
                                            
                                            {state.notas.map(val=>
                                                <>
                                                    <Grid xs={2} >
                                                        <Item sx={{ m:1}}>
                                                            <Avatar alt={val.apellidos} src={val.foto} sx={{ width: 120, height: 120 }}/>
                                                        </Item>
                                                    </Grid>
                                                    <Grid xs={7}>
                                                        <Item sx={{ m:1}}>
                                                            <Typography variant="h6" gutterBottom sx={{fontWeight:'bold'}}>
                                                                {`${val.nombres} ${val.apellidos}`}
                                                            </Typography>
                                                        </Item>
                                                    </Grid>
                                                    <Grid xs={3}>
                                                        <Item sx={{ m:1}}>
                                                            <Typography variant="h6" gutterBottom sx={{fontWeight:'bold'}}>
                                                                {`${val.grado ? val.grado : ''} ${val.seccion ? val.seccion : ''}`}
                                                            </Typography>
                                                        </Item>
                                                    </Grid> 
                                            
                                                    <Grid xs={6}>
                                                        <Item sx={{ m:1}}>
                                                            <Typography variant="h6" gutterBottom sx={{fontWeight:'bold'}}>
                                                            {val.periodo}
                                                            <Stack 
                                                                    direction="row"
                                                                    sx={{pl:1}}
                                                            >
                                                                
                                                            </Stack>
                                                            </Typography>
                                                        </Item>
                                                    </Grid>
                                                    <Grid xs={6}>
                                                        <Item sx={{ m:1}}>
                                                            <Typography variant="h6" gutterBottom sx={{fontWeight:'bold'}}>
                                                                {val.grado} (PROMEDIO: {val.mensaje ? '?' : Number(val.promediol).toFixed(2)} ptos)
                                                            </Typography>
                                                        </Item>
                                                    </Grid>
                                                    <Grid container spacing={1}
                                                            sx={{
                                                                // justifyContent: "center",
                                                                
                                                            }}
                                                    >
                                                        <Grid item xs={12}>
                                                            {val.mensaje
                                                                ?
                                                                    <Item>
                                                                        <Typography variant="h5" gutterBottom sx={{fontWeight:'bold', color:'red'}}>
                                                                            {val.mensaje}
                                                                        </Typography>
                                                                    </Item>
                                                                :   <Item >
                                                                        <Stack 
                                                                            direction="row"
                                                                            sx={{pl:1}}
                                                                        >
                                                                            
                                                                            <Typography variant="subtitle" sx={{width:'40%', textAlign:'center', fontWeight:'bold'}} noWrap>
                                                                                ASIGNATURA
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{width:'15%', textAlign:'center', fontWeight:'bold'}}>
                                                                                1ER MOMENTO
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{width:'15%', textAlign:'center', fontWeight:'bold'}}>
                                                                                2DO MOMENTO
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{width:'15%', textAlign:'center', fontWeight:'bold'}}>
                                                                                3ER MOMENTO
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{width:'15%', textAlign:'center', fontWeight:'bold'}}>
                                                                                DEFINITIVA
                                                                            </Typography>
                                                                        </Stack>
                                                                        {NotasLapso(val)}
                                                                        <Stack 
                                                                            direction="row"
                                                                            sx={{pl:1}}
                                                                        >
                                                                            
                                                                            <Typography variant="subtitle" sx={{color:'#2c932f',width:'40%', textAlign:'left', fontWeight:'bold'}} noWrap>
                                                                                PROMEDIO
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{color:'#2c932f',width:'15%', textAlign:'right', fontWeight:'bold'}}>
                                                                                {Number(val.lapso1).toFixed(2)}
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{color:'#2c932f',width:'15%', textAlign:'right', fontWeight:'bold'}}>
                                                                                {Number(val.lapso2).toFixed(2)}
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{color:'#2c932f', width:'15%', textAlign:'right', fontWeight:'bold'}}>
                                                                                {Number(val.lapso3).toFixed(2)}
                                                                            </Typography>
                                                                            <Typography variant="subtitle" sx={{color:'#2c932f', width:'15%', textAlign:'right', fontWeight:'bold'}}>
                                                                                {Number(val.definitiva).toFixed(2)}
                                                                            </Typography>
                                                                        </Stack>
                                                                    </Item>
                                                            }
                                                        </Grid>
                                                        
                                                    </Grid>
                                                </>
                                            )}
                                            
                                        </Grid>
                                        :   null
                        
                            }
                        </Scrollbars>
                    </Box>
                </Grid>
            </Grid>
            
        </Box>
    )
}

export default NotasR;